<template>
  <a-spin :spinning="loading">
    <div class="handlingTraceContent">
      <a-table
        ref="tableRef"
        :rowkey="(_, index) => index"
        :dataSource="dataSource"
        :pagination="false"
        :columns="columns"
        :rowClassName="record => (record.processId == ctxTargetId ? 'targetRow' : '')"
      >
        <template #isReachDoctor="{ record }">
          <!-- 此处绑定需要滚动标识id -->
          <a-tag
            v-if="[1, 2, 4, 5, 6, 9].includes(record.traceType) && record.isReachDoctor !== null"
            :color="record.isReachDoctor ? 'cyan' : 'orange'"
          >
            <span :id="record.processId">
              {{ record.isReachDoctor ? '已触达' : '未触达' }}
            </span>
          </a-tag>
          <span v-else :id="record.processId">-</span>
        </template>
        <template #isReachPatient="{ record }">
          <a-tag
            v-if="
              [1, 3, 4, 5, 6, 7, 10].includes(record.traceType) && record.isReachPatient !== null
            "
            :color="record.isReachPatient ? 'cyan' : 'orange'"
          >
            {{ record.isReachPatient ? '已触达' : '未触达' }}
          </a-tag>
          <span v-else>-</span>
        </template>
        <template #isReachBd="{ record }">
          <a-tag
            v-if="[1, 2, 3, 4, 5, 6, 7].includes(record.traceType) && record.isReachBd !== null"
            :color="record.isReachBd ? 'cyan' : 'orange'"
          >
            {{ record.isReachBd ? '已触达' : '未触达' }}
          </a-tag>
          <span v-else>-</span>
        </template>
        <template #operation="{ record }">
          <span class="link" v-if="record.traceType !== 8" @click="handleTrace(record)">查看</span>
          <span v-else>-</span>
        </template>
      </a-table>
      <a-modal
        v-model:visible="traceVisible"
        :title="traceTypeList[traceInfo.type - 1]"
        :footer="null"
        :centered="true"
        width="70%"
        :bodyStyle="{
          height: '88vh',
          padding: '18px'
        }"
      >
        <callTraceRecord
          v-if="traceVisible && [4, 5, 6].includes(traceInfo.type)"
          :cdrIds="traceInfo.info?.msgOrTcccRecordIds"
        />
        <history
          v-if="traceVisible && [1, 2, 3, 7].includes(traceInfo.type)"
          :msgTraceId="traceInfo.info?.msgOrTcccRecordId"
          :groupId="traceInfo.type === 1 ? traceInfo.info?.msgGroupId : null"
          :doctorDaGroupId="traceInfo.type === 2 ? traceInfo.info?.msgGroupId : null"
          :privateId="traceInfo.type === 3 ? traceInfo.info?.msgGroupId : null"
          :guideConsultGroupId="traceInfo.type === 7 ? traceInfo.info?.msgGroupId : null"
        />
        <messageTrace
          ref="messageTraceRef"
          v-if="traceVisible && [9, 10].includes(traceInfo.type)"
        />
      </a-modal>
    </div>
  </a-spin>
</template>

<script setup>
import { defineProps, defineExpose, ref, onMounted, reactive, computed, nextTick } from 'vue'
import { apiQueryHandleTrace } from '@/api/workPlace/workOrder'
import { querySolidifyQualityTraceDetection } from '@/api/Todo/bdWorkorder'
import callTraceRecord from './callTraceRecord.vue'
import history from '@/views/WorkPlace/Container/chat/history.vue'
import messageTrace from './messageTrace.vue'
import { useStore } from 'vuex'

const props = defineProps({
  workOrderId: {
    type: String,
    default: '',
    required: true
  },
  ucUserId: {
    type: Number,
    default: 0
  },
  isBDOrder: {
    type: Boolean, //是否BD工单
    default: false
  },
  id: {
    // 子代办id
    type: Number,
    default: null
  }
})
const columns = computed(() => {
  if (props.isBDOrder) {
    return bdColums.concat(initColumns).filter(item => item.key !== 'isReachBd')
  } else {
    return assColumns.concat(initColumns)
  }
})
const store = useStore()
const ucPatientId = computed(() => {
  const patientId = props?.ucUserId || store.state.workOrder.workOrderGroupInfo.patientInfo.ucUserId
  if (patientId) {
    return Number(patientId)
  } else {
    return null
  }
})

const traceTypeList = [
  '三方会话',
  '医生私聊',
  '患者私聊',
  '医生虚拟电话',
  '患者虚拟电话',
  'BD虚拟电话',
  '导诊群',
  '无痕迹',
  '医生短信',
  '患者短信'
]

const dataSource = ref([])
onMounted(() => {
  !needScroll.value && queryTraceList()
})

const rowSpanRules = ref({})
const rowSpanIndexBegin = ref([])
const calcRowSpanQue = (list = []) => {
  rowSpanIndexBegin.value = []
  rowSpanRules.value = {}
  list.forEach((item, index) => {
    if (rowSpanRules.value[item.sortResults]) {
      rowSpanRules.value[item.sortResults]++
    } else {
      rowSpanIndexBegin.value.push(index)
      rowSpanRules.value[item.sortResults] = 1
    }
  })
}

const loading = ref(false)
const queryTraceList = async () => {
  try {
    loading.value = true
    const API = props.isBDOrder ? querySolidifyQualityTraceDetection : apiQueryHandleTrace
    const params = {
      workOrderId: props.workOrderId,
      adSubTaskId: props.id
    }
    const res = await API(params)
    dataSource.value = res || []
    calcRowSpanQue(res || [])
    loading.value = false
  } catch (error) {
    console.log('error', error)
  }
}

const messageTraceRef = ref(null)
const traceVisible = ref(false)
const traceInfo = reactive({
  type: null,
  info: {}
})
const handleTrace = record => {
  console.log('record', record)
  traceVisible.value = true
  traceInfo.type = Number(record.traceType)
  traceInfo.info = record
  nextTick(() => {
    if ([9, 10].includes(traceInfo.type)) {
      messageTraceRef.value.queryTraceByIds(record.smsIds)
    }
  })
}

const tableRef = ref(null)
const ctxTargetId = ref(null)
const needScroll = ref(false)
const activeCtxRow = ({ processId }) => {
  needScroll.value = true
  queryTraceList().then(() => {
    ctxTargetId.value = processId
    const target = document.getElementById(processId)
    target && target.scrollIntoView({ block: 'center', behavior: 'smooth' })
    setTimeout(() => {
      ctxTargetId.value = null
    }, 3000)
  })
}

const renderRowSpan = (record, key = '') => {
  const { text, index, record: rows } = record
  const label = key === 'dealingTime' ? rows.dealTimeBegin + '~' + rows.dealTimeEnd : text
  return {
    children: label,
    props: {
      rowSpan: rowSpanIndexBegin.value.includes(index)
        ? rowSpanRules.value[String(rows.sortResults)]
        : 0
    }
  }
}

const initColumns = [
  {
    title: '处理时间',
    dataIndex: 'dealingTime',
    key: 'dealingTime',
    customRender: record => renderRowSpan(record, 'dealingTime')
  },
  {
    title: '痕迹',
    dataIndex: 'traceName',
    key: 'traceName'
  },
  {
    title: '医生是否触达',
    dataIndex: 'isReachDoctor',
    key: 'isReachDoctor',
    slots: {
      customRender: 'isReachDoctor'
    }
  },
  {
    title: '患者是否触达',
    dataIndex: 'isReachPatient',
    key: 'isReachPatient',
    slots: {
      customRender: 'isReachPatient'
    }
  },
  {
    title: 'BD是否触达',
    dataIndex: 'isReachBd',
    key: 'isReachBd',
    slots: {
      customRender: 'isReachBd'
    }
  },
  {
    title: '操作',
    key: 'operation',
    width: 100,
    slots: {
      customRender: 'operation'
    }
  }
]
const assColumns = [
  {
    title: '处理顺序',
    dataIndex: 'sortResults',
    key: 'sortResults',
    customRender: record => renderRowSpan(record)
  },
  {
    title: '健管',
    dataIndex: 'dealUserName',
    customRender: record => renderRowSpan(record)
  }
]
const bdColums = [
  {
    title: 'BD',
    dataIndex: 'dealUserName',
    customRender: record => renderRowSpan(record)
  }
]
defineExpose({
  activeCtxRow
})
</script>
<style lang="scss" scoped>
.link {
  cursor: pointer;
  color: #1890ff;
}
</style>

<style lang="scss">
@keyframes rowShinning {
  50% {
    background-color: #fff5e7;
  }
}
.handlingTraceContent {
  .ant-table-content .targetRow {
    animation: rowShinning 1s ease-in-out infinite;
  }
}
</style>
